<div class="submit-button">
  <button [id]="'nc-submit-button-' + id" (click)="clickHandler()" color="primary" mat-raised-button [disabled]="disabled || isProcessing">
    {{buttonLabel | translate}}
  </button>
</div>
